import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

export function mapFileList(
  input: FileListFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'FileList'> {
  return {
    key: 'FileList',
    input: {
      items: input.files?.map((file) => ({
        title: file?.title || '',
        Link: buildLink({ href: file?.url || '' }),
      })),
    },
  };
}
